import { Collection, Plugin, UIModel, addListToDropdown, createDropdown } from 'ckeditor5';
/**
 * This plugin adds two buttons to the editor toolbar for converting legacy conditions and placeholders to the new format.
 * This is done after importing (pasting) a MD file into the editor.
 */
export class MarkdownToHTMLConversions extends Plugin {
    static get pluginName() {
        return 'MarkdownToHTMLConversions';
    }
    init() {
        this.registerToolbarItems();
    }
    registerToolbarItems() {
        const { editor } = this;
        editor.ui.componentFactory.add('legacyConversions', () => {
            const dropdown = createDropdown(editor.locale);
            const items = new Collection();
            dropdown.buttonView.set({
                withText: true,
                label: 'Convert',
                class: 'pleditor-toolbar-fa-icon-button',
                tooltip: 'Convert legacy conditions and placeholders',
                isEnabled: true,
            });
            items.add({
                type: 'button',
                model: new UIModel({
                    withText: true,
                    label: 'Convert Conditions',
                    commandName: 'convertConditions',
                }),
            });
            items.add({
                type: 'button',
                model: new UIModel({
                    withText: true,
                    label: 'Convert Placeholders',
                    commandName: 'convertPlaceholders',
                }),
            });
            items.add({
                type: 'button',
                model: new UIModel({
                    withText: true,
                    label: 'Convert Page breaks',
                    commandName: 'convertPageBreaks',
                }),
            });
            addListToDropdown(dropdown, items);
            dropdown.on('execute', (evt) => {
                const source = evt.source;
                switch (source.commandName) {
                    case 'convertConditions':
                        this.convertConditions();
                        break;
                    case 'convertPlaceholders':
                        this.convertPlaceholders();
                        break;
                    case 'convertPageBreaks':
                        this.convertPageBreaks();
                        break;
                    default:
                        break;
                }
            });
            return dropdown;
        });
    }
    convertConditions() {
        const { editor } = this;
        const conditionRegex = /\{\{([#^])([^}]+)\}\}([\s\S]*?)\{\{\/\2\}\}/g;
        const convertRecursive = (html) => html.replace(conditionRegex, (_, operator, id, content) => {
            const type = operator === '#' ? 'assume' : 'unless';
            const name = `${type}:${id}`;
            const convertedContent = convertRecursive(content);
            return `<condition-start name="${name}"></condition-start>${convertedContent}<condition-end name="${name}"></condition-end>`;
        });
        editor.setData(convertRecursive(editor.getData()));
    }
    convertPlaceholders() {
        const { editor } = this;
        // Match {{placeholder}} but NOT {{#...}} or {{^...}} or {{/...}}
        const placeholderRegex = /\{\{(?![#^/])([^}]+)\}\}/g;
        const convertRecursive = (html) => html.replace(placeholderRegex, (match, id) => `<span data-placeholder="${id}">${id}</span>`);
        editor.setData(convertRecursive(editor.getData()));
    }
    convertPageBreaks() {
        const { editor } = this;
        /**
         * Match <p>+++</p>. In MD there is a \n before and after +++.
         * However when we paste MD into the editor and have it converted to HTML,
         * the \n are not preserved, but transformed to <p></p> tags.
         */
        const pageBreakRegex = /<p>\+\+\+<\/p>/g;
        const convertRecursive = (html) => html.replace(pageBreakRegex, '<div class="page-break" style="page-break-after:always;"><span style="display:none;">&nbsp;</span></div>');
        editor.setData(convertRecursive(editor.getData()));
    }
}
